// client/src/components/influencer/InfluencerPointCheck.js
// 포인트 내역 보기 — A안 리디자인: 월렛 히어로 + 날짜 그룹 거래 리스트 (조회 로직은 기존 그대로)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';
const PAGE_SIZE = 20;

// 타입별 표시 텍스트
const TYPE_LABELS = {
  result_reward: '결과물 승인 보상',
  admin_approved_reward: '결과물 승인 보상',
  auto_approved_reward: '결과물 승인 보상',
  cps_reward: '구매당 리워드',
  cps_auto_reward: '구매당 리워드',
  cps_adjustment: '구매당 리워드 조정',
  point_adjustment: '포인트 조정',
  exchange_request: '환전 신청',
  exchange_approved: '환전 승인',
  exchange_rejected: '환전 거절',
};

// 타입별 아이콘 (장식용)
const TYPE_ICONS = {
  result_reward: '🎁',
  admin_approved_reward: '🎁',
  auto_approved_reward: '🎁',
  cps_reward: '💜',
  cps_auto_reward: '💜',
  cps_adjustment: '⚙️',
  point_adjustment: '🛠️',
  exchange_request: '🏦',
  exchange_approved: '✅',
  exchange_rejected: '⛔',
};

function InfluencerPointCheck() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [currentPoints, setCurrentPoints] = useState(0);
  const [pendingExchangePoints, setPendingExchangePoints] = useState(0);

  // 필터 상태
  const [filterType, setFilterType] = useState('all');
  const [period, setPeriod] = useState('1month');

  // 페이지네이션
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  // 내역 조회
  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filterType, period]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page,
        pageSize: PAGE_SIZE,
        type: filterType,
        period
      });

      const res = await fetch(`${API_URL}/api/influencer/mybiz/points/history?${params}`, {
        credentials: 'include'
      });
      const data = await res.json();

      if (data.ok) {
        setItems(data.items || []);
        setCurrentPoints(data.currentPoints || 0);
        setPendingExchangePoints(data.pendingExchangePoints || 0);
        setTotalPages(data.totalPages || 0);
      }
    } catch (error) {
      console.error('fetchHistory error:', error);
    }
    setLoading(false);
  };

  const getTypeLabel = (type) => TYPE_LABELS[type] || type;

  // 날짜별 그룹핑 (같은 날 거래를 한 그룹으로)
  const groups = [];
  items.forEach((item) => {
    const d = new Date(item.createdAt);
    const key = `${d.getMonth() + 1}월 ${d.getDate()}일`;
    const last = groups[groups.length - 1];
    if (last && last.key === key) last.items.push(item);
    else groups.push({ key, items: [item] });
  });

  return (
    <div>
      {/* 월렛 히어로 */}
      <div className="mbh-wallet" style={{ maxWidth: 420 }}>
        <div className="mbh-wallet__label">보유 포인트</div>
        <div className="mbh-wallet__amt">{currentPoints.toLocaleString()}<small>P</small></div>
        <div className="mbh-wallet__sub">
          {pendingExchangePoints > 0 ? `환전 신청 중 ${pendingExchangePoints.toLocaleString()}P 별도` : '등록된 통장으로 환전할 수 있어요'}
        </div>
        <div className="mbh-wallet__cta">
          <button type="button" className="mbh-btn-white" onClick={() => nav('/influencer/mybiz?sub=pointExchange')}>환전 신청</button>
        </div>
      </div>

      <div className="mb-card mb-card--full-height">
        <div className="mb-page-header">
          <h2 className="mb-page-title">포인트 내역 보기</h2>
          <p className="mb-page-description">적립·환전 내역을 한 줄씩 확인하세요.</p>
        </div>

        {/* 필터 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 6 }}>
          <div className="chips" style={{ margin: 0, flex: 1 }}>
            {['all', 'earn', 'exchange'].map(type => (
              <button
                key={type}
                type="button"
                onClick={() => { setFilterType(type); setPage(1); }}
                className={`chip${filterType === type ? ' is-active' : ''}`}
              >
                {type === 'all' && '전체'}
                {type === 'earn' && '적립'}
                {type === 'exchange' && '환전'}
              </button>
            ))}
          </div>

          <select
            value={period}
            onChange={(e) => { setPeriod(e.target.value); setPage(1); }}
            style={{
              height: 36, borderRadius: 999, border: '1.5px solid #eceef2', padding: '0 14px',
              fontSize: 13.5, fontWeight: 600, color: '#3b4658', background: '#fff', fontFamily: 'inherit',
            }}
          >
            <option value="1month">최근 1개월</option>
            <option value="3months">최근 3개월</option>
            <option value="6months">최근 6개월</option>
            <option value="1year">최근 1년</option>
            <option value="all">전체</option>
          </select>
        </div>

        {/* 거래 리스트 (날짜 그룹) */}
        {loading && (
          <div className="mbh-loading">불러오는 중…</div>
        )}
        {!loading && items.length === 0 && (
          <div className="mbh-todo__empty" style={{ marginTop: 12 }}>
            선택한 기간에 내역이 없어요. 기간을 바꿔서 확인해보세요.
          </div>
        )}
        {!loading && groups.map((group) => (
          <div key={group.key}>
            <div className="mbh-txn-date">{group.key}</div>
            {group.items.map((item) => (
              <div className="mbh-txn" key={item._id}>
                <span className="mbh-txn__ico" aria-hidden="true">{TYPE_ICONS[item.type] || '•'}</span>
                <span className="mbh-txn__meta">
                  <span className="mbh-txn__t">{getTypeLabel(item.type)}{item.projectNumber ? ` · #${item.projectNumber}` : ''}</span>
                  <span className="mbh-txn__s">
                    {new Date(item.createdAt).toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' })}
                    {item.memo ? ` · ${item.memo}` : ''}
                  </span>
                </span>
                <span className={`mbh-txn__amt${item.amount > 0 ? ' in' : ''}`}>
                  {item.amount > 0 ? '+' : ''}{item.amount.toLocaleString()}
                  <span className="bal">
                    {item.balanceAfter !== null ? `잔액 ${item.balanceAfter.toLocaleString()}` : '—'}
                  </span>
                </span>
              </div>
            ))}
          </div>
        ))}

        {/* 페이지네이션 */}
        {totalPages > 1 && (
          <div className="pager">
            <button
              type="button"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              ‹
            </button>
            {page} / {totalPages}
            <button
              type="button"
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              ›
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default InfluencerPointCheck;
